import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';

import { ShortNameModule } from '@frontend/sports/betting-offer/feature/short-team-names';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { PopularBetsPodTypes } from '@frontend/sports/types/components/popular-bets';
import { RxFor } from '@rx-angular/template/for';

import { EventNameMapperService } from '../../../event-details-common/event-name-mapper.service';
import { PopularBetsPodEventLogoComponent } from '../../popular-bets-pod-event-logo/popular-bets-pod-event-logo.component';
import { PopularBetsPodOptionService } from '../../popular-bets-services/popular-bets-pod-option.service';
import { IPreCreatedOption } from '../../popular-bets.models';

@Component({
    selector: 'ms-popular-bets-bet-builder-options',
    templateUrl: './popular-bets-bet-builder-options.component.html',
    styleUrl: './popular-bets-bet-builder-options.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RxFor, SlicePipe, PopularBetsPodEventLogoComponent],
})
export class PopularBetsBetBuilderOptionsComponent {
    @HostBinding('class') className = 'popular-bets-bet-builder-options';

    options = input.required<IPreCreatedOption[]>();
    visibleOptionsLimit = input.required<number>();
    isEpcotEnabled = input.required<boolean>();
    showMoreLessButtonVisible = input.required<boolean>();
    totalEventCount = input.required<number>();
    event = input.required<GridEvent>();
    private showOpponent: boolean;

    readonly shouldShowConnector = computed(() => {
        const allLegsVisible = this.totalEventCount() - this.visibleOptionsLimit() <= 0;
        return !allLegsVisible && this.showMoreLessButtonVisible() && !this.isEpcotEnabled();
    });

    constructor(
        private podOptionService: PopularBetsPodOptionService,
        private eventNameMapper: EventNameMapperService,
    ) {
        this.showOpponent = this.podOptionService.getOpponentEnabledByPodType(PopularBetsPodTypes.SGP);
    }

    trackOption(index: number): number {
        return index;
    }

    get eventTitle(): string {
        return this.eventNameMapper.map(this.event(), false, ShortNameModule.PopularBets);
    }

    getSelectionInfo(option: IPreCreatedOption): string {
        if (!option) {
            return '';
        }

        if (!this.showOpponent) {
            return option.name;
        }

        return this.podOptionService.getOpponentSelection(this.event(), option.name, this.eventTitle, option.opponentParticipant);
    }
}
